import "../../styles/gallery.css";
import Footer from "../../components/footer";
import Header from "../../components/header";
import GalleryMain from "./galleryMain";

function Gallery() {
  return (
    <div>
      <Header />
      <GalleryMain />
      <Footer />
    </div>
  );
}

export default Gallery;
